// Base
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { EqualHeightProvider } from "./EqualHeightContext";

export function EqualHeight(props) {
  const { children, animate, responsiveUpdate } = props;
  const [sizes, setSizes] = useState([]);
  const [forceUpdateSize, setForceUpdateSize] = useState(false);

  const handleResize = () => setSizes([]);

  if (responsiveUpdate) {
    useEffect(() => {
      let timer;

      window.addEventListener("resize", () => {
        clearTimeout(timer);
        timer = setTimeout(handleResize, 200);
      });

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
  }

  useEffect(() => {
    handleResize();
  }, [forceUpdateSize]);

  return (
    <EqualHeightProvider
      value={{
        sizes,
        setSizes,
        animate,
        forceUpdateSize,
        setForceUpdateSize,
      }}
    >
      {children}
    </EqualHeightProvider>
  );
}

// Props
EqualHeight.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  animate: PropTypes.bool,
  responsiveUpdate: PropTypes.bool,
};

EqualHeight.defaultProps = {
  animate: false,
  responsiveUpdate: false,
};

EqualHeight.displayName = "EqualHeight";

export default EqualHeight;
